import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import { withRouter } from "react-router-dom";
import { Button, Icons } from "cakemail-ui-components/lib/react";
import classNames from "classnames";
import CreateMenuDropdown from "./CreateMenuDropdown";

export class CreateMenuButton extends Component {
	constructor(props) {
		super(props);

		this.state = {
			active: false,
		};

		this.changeStatus = this.changeStatus.bind(this);
	}

	changeStatus() {
		this.setState({
			active: !this.state.active,
		});
	}

	render() {
		let dropDown = null;
		let containerClasses = classNames("create-container", {
			opened: this.state.active,
		});

		if (this.state.active === true) {
			dropDown = (
				<CreateMenuDropdown
					{...this.props}
					changeStatus={this.changeStatus}
					createRef={this.createRef}
				/>
			);
		}

		return (
			<div
				className={containerClasses}
				ref={(ref) => {
					this.createRef = ref;
				}}
			>
				<div data-test="create-container" onClick={this.changeStatus}>
					<Button
						size="small"
						shapeStyle="stroke"
						colorTheme="teal"
						radius="round"
						icon={true}
					>
						<Translate value="app-menu-tab-button-create" />
						<Icons name="micro-glyph-arrow-head" type="micro-glyph-teal" />
					</Button>
				</div>

				{dropDown}
			</div>
		);
	}
}

export default withRouter(CreateMenuButton);
